<template>
<div ref="scroller" style="overflow-y:auto;scroll-behavior: smooth">
    <slot></slot>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        item: Object,
        
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        setupScrolling() {
            this.$refs.scroller.addEventListener('DOMNodeInserted', (e) => {
                this.scrollToBottom(e)
            })
        },

        scrollToLastElement() {
            let el = this.$refs.scroller.lastChild
                if(el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'end' }); 
                    this.$emit('change')
            }
        },

        scrollToBottom(e) {
            let el = this.$refs.scroller
            
            if(e && e.target && e.target.className && e.target.className.indexOf('tooltip') > -1) {
                console.log('not scrolling')
                return
            }

            el.scrollTop = el.scrollHeight
        }
    },

    mounted() {
        setTimeout( () => {
            this.scrollToBottom()
            this.setupScrolling()
        },500)
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ScrollDownDiv.vue?4a21a550